import { Navigate } from 'react-router-dom';
import { LoadingOverlay } from '@/components/core';
import { useMe } from '@/api-client/use-me';
import { useGetUserProfiles } from '@/graphql';
import { useUserStore } from '@/store';

export function HomeRedirect() {
  const { data: profile, isLoading: isProfileLoading } = useMe();
  const user = useUserStore((state) => state.user);
  const userId = profile?.itemId ?? user?.itemId;
  const { data, isLoading: isUserProfileLoading } = useGetUserProfiles({
    where: userId ? { BlocksUserId: { eq: userId } } : {},
    paging: { pageNo: 1, pageSize: 1 },
  });
  const userProfile = data?.getUserProfiless?.items?.[0];

  if (isProfileLoading || (!!userId && isUserProfileLoading)) {
    return <LoadingOverlay />;
  }

  if (userProfile?.OnboardingCompleted === true) {
    return <Navigate to="/org/select" replace />;
  }

  return <Navigate to="/onboarding" replace />;
}
